import { SamaritanMemberSmallTemplate } from '../../hooks/useAdminMemberSearch';

import AdminMemberCard from './AdminMemberCard';

import { Box, Grid } from '@mui/material';

interface SearchResultsProps {
    members: SamaritanMemberSmallTemplate[];
}

const SearchResults: React.FC<SearchResultsProps> = ({ members }) => {
    return (
        <Box sx={{ paddingLeft: 2, paddingRight: 2, paddingBottom: 2, width: '96%' }}>
            <Grid container spacing={2}>
                {members.map((member: SamaritanMemberSmallTemplate) => (
                    <Grid item xs={12} sm={6} md={4} key={`member-${member.id}`} sx={{ height: 200 }}>
                        <AdminMemberCard member={member} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default SearchResults;